import {
  getFiles,
  loadPath,
  saveFile,
  deleteFils,
  moveFiles,
  copy,
  download,
  createFile,
  emptyTrash,
  rename,
  recover,
  deleteP,
  checkEmail,
  closeEmailTip,
  sendEmail
} from '../service/index'
import {
  cancelShare
} from '../service/share'
import {
  createFolder
} from '../service/common'
import {
  star,
  unstar
} from '../service/starred'
import {
  pageCount
}
from '../../../src/config'
export default {
    namespaced: true,
    state(){
        return {
            fileList: [],
            fileids: [],
            breads: [],
            initing: true,
            currentPage: 1,
            filter: 'all',
            maxPage: false,
            auto: false,
            search: '',
            trash: false,
            doing: false,
            loading: false,
            fid: -1,
            createData:{

            },
            remind: {
              getStatus: false,
              email: {
                value: ''
              }
            },
            sendCount: 0,
            shareRoute:''
        }
    },
    getters:{
        shouldFlush(state){
            return !state.auto && !state.search && !state.trash
        }
    },
    mutations:{
        INIT(state,{pid,auto,search,trash,noinit,clear,fid}){
            state.auto = !!auto
            state.search = search || ''
            state.trash = !!trash
            !noinit || clear ? state.fileList = [] : ''
            state.fileids = []
            state.initing = !noinit 
            state.currentPage = 1
            state.loading = false
            state.maxPage = false
            state.fid = fid || -1
        },
        UPDATE_FILES(state,list){
            state.fileids = []
            state.fileList = state.fileList.filter(item => list.indexOf(item.id) < 0)
        },
        UPDATE_LIST(state){
            state.fileids = []
        },
        SAVE_FILES(state,{list,noinit}){
            state.currentPage === 1 ? state.initing = false : null
            state.currentPage += 1
            state.maxPage = list.length < pageCount
            state.fileList = noinit ? list : state.fileList.concat(list)
        },
        CHECK_ITEM(state, {fileid,shift}) {
            fileid = Number(fileid)
            let list = state.fileids
            let idx = list.indexOf(fileid)
            if (shift && list.length) {
                let uplist = []
                let downlist = []
                let flag = false
                state.fileList.map(item => {
                    let itemid = item.id || item.fileid
                    itemid === fileid ? flag = true : ''
                    flag ? downlist.push(itemid) : uplist.push(itemid)
                })
                let originIdx = uplist.length
                let upIndex
                let downIndex
                uplist.map((item, i) => {
                    list.indexOf(item) > -1 && typeof upIndex === 'undefined' ? upIndex = i : ''
                })
                if (typeof upIndex == 'number') {
                    uplist.slice(upIndex + 1).map(item => {
                        let upidx = list.indexOf(item)
                        upidx < 0 ? list.push(item) : ''
                    })
                    list.indexOf(downlist[0]) < 0 ? list.push(downlist[0]) :  ''
                }else {
                    downlist.map((item, i) => {
                      list.indexOf(item) > -1 ? downIndex = i  : ''
                    })
                    if (typeof downIndex == 'number') {
                        downlist.slice(0,downIndex).map(item => {
                            let downidx = list.indexOf(item)
                            downidx < 0 ? list.push(item) : ''
                        })
                    }
                }
            }
            idx > -1 && !shift ? list.splice(idx, 1) : !shift ? list.push(fileid) : ''
            state.fileids = list
        },
        SAVE_STAR(state, {
            fileid,
            ctime
          }) {
            ctime ? 
            state.fileList.map(item => item.id === fileid ? item.stared = 1 : '') :
            state.fileList.map(item => item.id === fileid ? item.stared = 0 : '')
        },
        SAVE_PATH(state,list){
            list.map(item => {
                item.cos = false
            })
            state.breads = list
        },
        UPDATE_BREADS(state){
            state.breads = []
        },
        RESET_BREADS(state,fileid){
            state.breads.map(item => {
                item.fileid === fileid ? item.cos = true : item.cos = false
            })
        },
        UPDATE_NAME(state,{fileid,fname}){
            state.fileList.map(item => {
                item.id === fileid ? item.fname = fname : ''
            })
        },
        DOING(state,flag){
            state.doing = flag
        },
        LOADING(state, flag) {
          state.loading = flag
        },
        SAVE_CREATE(state,paload){
          state.createData = paload
        },
        SAVE_EMAIL_STATUS(state,data){
          state.remind = {
            getStatus: true,
            ...data
          }
        },
        SEND_SUCCESS(state){
          state.sendCount = state.sendCount + 1
        },
        UPDATE_SHARE(state,route){
          state.shareRoute = route
      }
    },
    actions:{
        flush({commit,dispatch,state},paload){
            let pid = typeof paload === 'Number' ? paload : paload.parentid
            commit('INIT',{pid,noinit: true,auto:state.auto,search:state.search })
            dispatch('loadmore',{noinit: true,auto:state.auto,search:state.search })
        },
        loadmore({commit,state,rootState},paload){
            if (state.maxPage || state.loading) {
              return
            }

            commit('LOADING', true)
            let filter = state.filter
            let orderby = rootState.orderby || 'mtime'
            let order = rootState.order || 'DESC'
            let parentid = rootState.parentid
            let offset = (state.currentPage - 1) * pageCount
            let groupid 
            if (rootState.route == 'teams'){
                groupid = rootState.teamRoute.tid
            }
            let pdata = {
              count: pageCount,
              offset,
              filter,
              group: groupid || state.auto ? rootState.autoGroup : rootState.group,
              search: state.search || '',
              trash: state.trash,
              fid: state.fid,
              orderby,
              order,
              parentid
            }
            if (rootState.route == 'teams') {
              let {tid,fid} = rootState.teamRoute
              pdata = {
                ...pdata,
                tid,
                fid
              }
            }
            getFiles(pdata,({status,data}) => {
                if (status === 200) {
                    commit('SAVE_FILES',{
                        list: data.files || data,
                        noinit: paload && paload.noinit
                    })
                }else{
                    commit('SAVE_FILES',{
                        list: [],
                        noinit: true
                    })
                    commit('TOAST', {
                      type: 'error',
                      msg: data.result
                    }, {
                      root: true
                    })
                }
                commit('LOADING', false)
            })
        },
        saveFile({commit,rootState,dispatch,state,getters},paload){
            return saveFile(paload,({status,data}) => {
                // if (status == 200) {
                //     if (paload.parentid == rootState.parentid && getters.shouldFlush) {
                //         dispatch('flush',paload.parentid)
                //     }
                // }else{
                //     commit('SAVE_FAILED')
                // }
            })
        },
        loadPath({commit},paload){
            loadPath(paload,({status,data}) => {
                if (status === 200) {
                    commit('SAVE_PATH',data.path)
                }else{
                    commit('SAVE_PATH', [])
                    commit('TOAST', {
                      type: 'error',
                      msg: data.result
                    }, {
                      root: true
                    })
                }
            })
        },
        star({commit,state,rootState,dispatch},{fileid,sid,groupid}){
            let route =rootState.route
            let gid = groupid || (state.auto ? rootState.autoGroup : rootState.group)
            let paload = {
              fileid,
              from: state.auto ? 'roaming' : route == 'all' ? 'personal' : route == 'latest' ? 'recent' : route == 'received' ? state.shareRoute == 'shared' ? 'personal' : 'share' : route == 'teams' ? 'team' : ''
            }
            if (sid && state.shareRoute != 'shared') {
              delete paload.fileid
              paload.sid = sid
            }else{
              paload.groupid = gid
            }
            star(paload,({status,data}) => {
                if (status === 200) {
                    _dw.onEvent('drive_fileaction_star',{
                        type: 'success'
                    })
                    route == 'all' || route == 'teams' ?
                    commit('SAVE_STAR',data) :
                    route == 'latest' ? dispatch('flush',{
                        smodule: 'latest',
                        action: 'updateStar',
                        paload:{
                            fileid,
                            type: 'star'
                        }
                    },{
                        root: true
                    }): route == 'received' ? 
                    state.shareRoute == 'shared' ? dispatch('flush', {
                        smodule: 'received',
                        action: 'updateStar',
                        paload: {
                            fileid,
                            type: 'star'
                        }
                    }, {
                      root: true
                    }) : dispatch('flush', {
                      smodule: 'received',
                      action: 'updateStar',
                      paload: {
                          sid,
                          type: 'star'
                      }
                  }, {
                    root: true
                  }) : ''
                }else{
                    _dw.onEvent('drive_fileaction_star', {
                      type: 'failed',
                      result: data.result
                    })
                    commit('TOAST', {
                      type: 'error',
                      msg: data.result
                    }, {
                      root: true
                    })
                }
            })
        },
        unstar({commit,rootState,dispatch,state},{fileid,sid}){
            let route = rootState.route
            let paload = sid ? {sid} : {fileid}
            unstar(paload,({status,data}) => {
                if (status === 200) {
                    _dw.onEvent('drive_fileaction_unstar', {
                      type: 'success'
                    })
                  commit('SAVE_STAR', {...data,fileid})
                  if (route == 'starred') {
                      dispatch('flush',{
                          smodule: 'starred',
                          action: 'flush'
                      },{root: true})
                  }else if(route == 'latest'){
                        dispatch('flush',{
                            smodule: 'latest',
                            action: 'updateStar',
                            paload: {
                                fileid,
                                type: 'unstar'
                            }
                        },{root: true})
                  }else if(route == 'received'){                  
                    if(state.shareRoute == 'shared'){
                        dispatch('flush', {
                            smodule: 'received',
                            action: 'updateStar',
                            paload: {
                                fileid,
                                type: 'unstar'
                            }
                        }, {root: true})
                    }else{
                        dispatch('flush', {
                            smodule: 'received',
                            action: 'updateStar',
                            paload: {
                                sid,
                                type: 'unstar'
                            }
                        }, {
                            root: true
                        })
                    }
                  }

                } else {
                    _dw.onEvent('drive_fileaction_unstar', {
                      type: 'success',
                      result: data.result
                    })
                  commit('TOAST', {
                    type: 'error',
                    msg: data.result
                  }, {
                    root: true
                  })
                }
            })
        },
        doCreate({commit,rootState,dispatch,getters},paload){
            let create
            let isfile = ['xls', 'doc', 'ppt'].indexOf(paload.type) > -1
            let filetype = paload.type || 'folder'
            if (isfile) {
                create = createFile
            }else{
                create = createFolder
            }
            delete paload.type
            commit('DOING',true)
            create(paload,({status,data}) => {
                commit('DOING', false)
                if (status == 200) {
                    _dw.onEvent(`drive_create`, {
                        result: 'success',
                        filetype
                    })
                    commit('SAVE_CREATE',data)
                    if (paload.parentid == rootState.parentid && getters.shouldFlush && isfile) {
                        dispatch('flush', paload.parentid)
                    }
                    if (isfile) {
                        dispatch('flush',{noinit: true,action: 'flush',smodule: 'events'},{root:true})
                    }

                }else{
                    _dw.onEvent(`drive_create`, {
                      result: 'failed',
                      filetype
                    })
                    commit('TOAST', {
                      type: 'error',
                      msg: data.result
                    },{root:true})
                }
                
            })
        },
        deleteFiles({commit,state,dispatch,rootState},{fileid,groupid}){
            let fileids = fileid ? [fileid] : state.fileids
            let route = rootState.route
            commit('DOING', true)
            deleteFils({
                groupid: groupid,
                fileids,
            },({status,data})=>{
                commit('DOING', false)
                if (status === 200) {
                    _dw.onEvent('drive_fileaction_delete', {
                      type: 'success'
                    })
                    commit('UPDATE_FILES', fileids)

                    dispatch('close',{},{root:true})
                    commit('TOAST',{
                        type: 'success',
                        msg: 'deleteSucc'
                    },{root:true})
                    if (route == 'starred') {
                        dispatch('flush', {
                          smodule: 'starred',
                          action: 'flush'
                        }, {
                          root: true
                        })
                        dispatch('flush', {
                          smodule: 'events',
                          action: 'flush'
                        }, {
                          root: true
                        })
                    }else if(route == 'latest'){
                        dispatch('flush', {
                          smodule: 'latest',
                          action: 'flush'
                        }, {
                          root: true
                        })
                        dispatch('flush', {
                          smodule: 'events',
                          action: 'flush'
                        }, {
                          root: true
                        })
                    }else if(route == 'teams'){
                      dispatch('flush', {
                        smodule: 'events',
                        action: 'flush'
                      }, {
                        root: true
                      })
                      commit('INIT', {
                        noinit: true
                      })
                      dispatch('loadmore', {
                        noinit: true
                      })
                    } else if(state.search){
                        commit('INIT', {
                          search: state.search,
                          noinit: true
                        })
                        dispatch('loadmore', {
                          noinit: true
                        })
                    }
                }else{
                    _dw.onEvent('drive_fileaction_delete', {
                      type: 'failed',
                      result: data.result
                    })
                    commit('TOAST', {
                      type: 'error',
                      msg: data.result
                    }, {
                      root: true
                    })
                }
                
            })
        },
        moveFiles({commit,state,dispatch,rootState,getters},{target_parentid,target_groupid,fileid,groupid}){
            let fileids = state.fileids
            let route = rootState.route
            commit('DOING', true)
            moveFiles({
                groupid,
                target_groupid,
                fileids: fileid ? [fileid] : fileids,
                target_parentid
            },({status,data})=>{
                commit('DOING', false)
                if (status === 200) {
                    _dw.onEvent('drive_fileaction_move', {
                        type: 'success'
                    })
                    dispatch('close',{},{root:true})
                    commit('TOAST',{
                        type: 'success',
                        msg: 'Movesuccess'
                    },{root:true})
                    if (route == 'teams') {
                      dispatch('flush', {
                        smodule: 'events',
                        action: 'flush',
                        paload: {
                          noinit: true
                        }
                      }, {
                        root: true
                      })
                      commit('INIT', {
                        noinit: true
                      })
                      dispatch('loadmore', {
                        noinit: true
                      })
                    }else if (state.auto || route == 'all') {
                        commit('INIT',{auto: state.auto,search: state.search,noinit: true})
                        dispatch('loadmore',{noinit: true})
                    }else if(route == 'starred'){
                        dispatch('flush', {
                          smodule: 'starred',
                          action: 'flush'
                        }, {
                          root: true
                        })
                    }else if(route == 'latest'){
                        dispatch('flush', {
                          smodule: 'latest',
                          action: 'flush'
                        }, {
                          root: true
                        })
                    }else if(state.shareRoute == 'shared'){
                        dispatch('flush', {
                          smodule: 'received',
                          action: 'flush'
                        }, {
                          root: true
                        })
                        dispatch('flush', {
                          smodule: 'events',
                          action: 'flush',
                          paload: {
                            noinit: true
                          }
                        }, {
                          root: true
                        })
                    }
                }else {
                    _dw.onEvent('drive_fileaction_move', {
                      type: 'failed',
                      result: data.result
                    })
                    commit('TOAST', {
                      type: 'error',
                      msg: data.result
                    }, {
                      root: true
                    })
                }
                
            })
        },
        copy({commit,rootState,state,dispatch,getters},{target_parentid,target_groupid,fileid,groupid}){
            let route = rootState.route
            commit('DOING', true)
            copy({
                groupid,
                target_groupid,
                target_parentid,
                fileids: fileid ? [fileid] : state.fileids
            },({status,data}) => {
                commit('DOING', false)
                if (status === 200) {
                    _dw.onEvent('drive_fileaction_copy', {
                      type: 'success'
                    })
                    dispatch('close',{},{root:true})
                    commit('TOAST',{
                        type: 'success',
                        msg: 'Copysuccess'
                    },{root:true})
                    if (groupid == target_groupid && getters.shouldFlush) {
                        dispatch('flush',target_parentid)
                    }
                    if (route == 'starred' || route == 'latest' || route == 'teams') {
                        dispatch('flush',{
                            smodule: 'events',
                            action: 'flush',
                            paload: {
                                noinit: true
                            }
                        },{root:true})
                    }else if(state.search){
                        commit('INIT', {
                          search: state.search,
                          noinit: true
                        })
                        dispatch('loadmore', {
                          noinit: true
                        })
                    }
                }else {
                    _dw.onEvent('drive_fileaction_copy', {
                      type: 'copy',
                      result: data.result
                    })
                    commit('TOAST', {
                      type: 'error',
                      msg: data.result
                    }, {
                      root: true
                    })
                }
                
            })
        },
        download({commit,state,rootState},{fileid,groupid,sid,historyid}){
          if (!groupid && !fileid) {
            fileid  = state.fileids[0]
            state.fileList.map(item => {
              item.id == fileid ? groupid = item.groupid : ''
            })
          }
            download({
                groupid,
                fileid,
                sid,
                historyid
            },({status,data})=>{
                if (status === 200) {
                    _dw.onEvent('drive_download',{
                        type: 'success',
                        dwtype: historyid ? 'history' : 'file'
                    })
                    let url = data.fileinfo ? data.fileinfo.url : data.download_url
                    commit('UPDATE_URL',{url} ,{root:true})
                }else{
                    _dw.onEvent('drive_download', {
                      type: 'success',
                      dwtype: historyid ? 'history' : 'file',
                      result: data.result
                    })
                    commit('TOAST', {
                      type: 'error',
                      msg: data.result
                    }, {
                      root: true
                    })
                }
            })
        },
        emptyTrash({commit,dispatch,state}){
            commit('DOING', true)
            let paload = state.fid ? {parent:state.fid} : {}
            emptyTrash(paload,({status,data}) => {
                commit('DOING', false)
                if (status === 200) {
                    _dw.onEvent('drive_recycle_empty', {
                      type: 'success',
                      action: 'empty'
                    })
                    dispatch('close',{},{root:true})
                    commit('TOAST',{
                        type: 'success',
                        msg: 'Emptied'
                    },{root:true})
                    commit('INIT', {trash:true,noinit: true,clear: true})
                    // dispatch('loadmore')
                }else {
                    _dw.onEvent('drive_recycle_empty', {
                      type: 'failed',
                      action: 'empty',
                      result: data.result
                    })
                    commit('TOAST', {
                      type: 'error',
                      msg: data.result
                    }, {
                      root: true
                    })
                }
                
            })
        },
        rename({commit,rootState,dispatch,state},{fname,fileid}){
            let route = rootState.route
            commit('DOING', true)
            rename({fname,groupid: rootState.dialogData.groupid,fileid},({status,data}) => {
                commit('DOING', false)
                if (status === 200) {
                    _dw.onEvent('drive_fileaction_rename', {
                      type: 'success'
                    })
                    dispatch('close',{},{root:true})
                    commit('TOAST',{
                        type: 'success',
                        msg: 'Renamed'
                    },{root:true})
                    dispatch('renameSuccess',{fname,fileid})
                }else{
                    _dw.onEvent('drive_fileaction_rename', {
                      type: 'failed',
                      result: data.result
                    })
                    commit('TOAST', {
                      type: 'error',
                      msg: data.result
                    }, {
                      root: true
                    })
                }
                
            })
        },
        renameSuccess({commit,dispatch,state,rootState},{fileid,fname}){
          let route = rootState.route
          if (route == 'teams') {
              commit('INIT', {
                noinit: true
              })
              dispatch('loadmore', {
                noinit: true
              })
              dispatch('flush', {
                smodule: 'events',
                action: 'flush',
                paload: {
                  noinit: true
                }
              }, {
                root: true
              })
            }else if (route == 'starred') {
              dispatch('flush', {
                smodule: 'starred',
                action: 'rename',
                paload: {
                  fileid,
                  fname
                }
              }, {
                root: true
              })
              dispatch('flush', {
                smodule: 'events',
                action: 'flush',
                paload: {
                  fileid,
                  fname
                }
              }, {
                root: true
              })
            } else if (route == 'latest') {
                  dispatch('flush', {
                    smodule: 'latest',
                    action: 'flush'
                  }, {
                    root: true
                  })
            } else if(state.shareRoute == 'shared'){
                dispatch('flush', {
                    smodule: 'received',
                    action: 'flush'
                  }, {
                    root: true
                  })
                  dispatch('flush', {
                    smodule: 'events',
                    action: 'flush',
                    paload: {
                      fileid,
                      fname
                    }
                  }, {
                    root: true
                  })
            } else if (state.auto || route == 'all') {
                commit('INIT', {
                  auto: state.auto,
                  search: state.search,
                  noinit: true
                })
                dispatch('loadmore', {
                  noinit: true
                })
              } else {
                  commit('UPDATE_NAME', {
                    fileid,
                    fname
                  })
              }
        },
        recover({commit,dispatch,state},fileid){
            commit('DOING', true)
            let fileids = fileid ? [fileid] : state.fileids
            recover({
                fileids
            },({status,data}) => {
                commit('DOING', false)
                if (status === 200) {
                    _dw.onEvent('drive_recycle', {
                      type: 'success',
                      action: 'recover'
                    })
                    dispatch('close',{},{root:true})
                    commit('TOAST',{
                        type: 'success',
                        msg: 'Recovered'
                    },{root:true})
                    commit('INIT',{trash: true,noinit: true,fid: state.fid})
                    dispatch('loadmore',{noinit: true})
                }else{
                    _dw.onEvent('drive_recycle', {
                      type: 'failed',
                      action: 'recover',
                      result: data.result
                    })
                    commit('TOAST', {
                      type: 'error',
                      msg: data.result
                    }, {
                      root: true
                    })
                }
                
            })
        },
        deleteP({commit,dispatch,state},fileid){
            commit('DOING', true)
            let fileids = fileid ? [fileid] : state.fileids
            deleteP({
                fileids
            },({status,data}) => {
                commit('DOING', false)
                if (status === 200) {
                    _dw.onEvent('drive_recycle', {
                      type: 'success',
                      action: 'delete'
                    })
                    dispatch('close',{},{root:true})
                    commit('TOAST',{
                        type: 'success',
                        msg: 'deleteSucc'
                    },{root:true})
                    commit('INIT',{trash: true,noinit: true,fid:state.fid})
                    dispatch('loadmore',{noinit: true})
                }else{
                    _dw.onEvent('drive_recycle', {
                      type: 'failed',
                      action: 'delete',
                      result: data.result
                    })
                    commit('TOAST', {
                      type: 'error',
                      msg: data.result
                    }, {
                      root: true
                    })
                }
                
            })
        },
        stopShare({commit,dispatch,rootState},){
          let {dialogData:{fileid,groupid,dialogIco,dialogTitle}} = rootState
          commit('DOING', true)
          cancelShare({
            fileid,groupid
          },({status,data}) => {
            if (status == 200) {
              if(rootState.dialogData.share == 'shared'){
                dispatch('flush', {
                  smodule: 'received',
                  action: 'flush'
                }, {
                  root: true
                })
                dispatch('close',{},{root:true})
              }else{
                commit('SHOW_DIALOG',{
                  current: 'Share',
                  size: 'large',
                  title: dialogTitle,
                  dialogIco,
                  dialogData: {
                    ...rootState.dialogData,
                    link: 'share',
                    Onshare: true,
                  }
                },{root:true})
                // dispatch('flush', {
                //   smodule: 'received',
                //   action: 'flush'
                // }, {
                //   root: true
                // })
              }   
            }else{
              commit('TOAST', {
                type: 'error',
                msg: data.result
              }, {
                root: true
              })
            }
            commit('DOING', false)
          })
          
        },
        checkEmail({commit},paload){
          checkEmail(({status,data}) => {
            if (status == 200) {
              commit('SAVE_EMAIL_STATUS', data)
            }
          })
        },
        closeEmailTip({commit}){
          closeEmailTip(({status,data}) => {
            if (status == 200) {
              commit('SAVE_EMAIL_STATUS', {
                email: {}
              })
            }
          })
        },
        sendEmail({commit,state,dispatch}){
          sendEmail(state.remind.email.value,({status,data}) => {
            if (status == 200) {
              commit('SEND_SUCCESS')
              dispatch('closeEmailTip')
            }else{
              commit('TOAST', {
                type: 'error',
                msg: data.result
              }, {
                root: true
              })
            }
          })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/index.js